"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = exports.StyledButtonContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../../Buttons/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "ConfirmationModalstyles__StyledButtonContainer",
  componentId: "sc-178m7jh-0"
})(["display:flex;flex-direction:column;justify-content:center;align-content:center;align-items:center;"]);

exports.StyledButtonContainer = StyledButtonContainer;
var StyledButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "ConfirmationModalstyles__StyledButton",
  componentId: "sc-178m7jh-1"
})(["max-width:50%;"]);
exports.StyledButton = StyledButton;